import React from 'react';
import PropTypes from 'prop-types';
import { MenuItem, Select } from '@mui/material';
import {
  useGetSharedProgrammesQuery,
  useGetSpaceQuery,
} from '../../app/smorgAppSyncGraphQLApi';

const AppLinkObjectIDPickerSharedProgrammes = ({
  objectID,
  onChangeObjectID,
}) => {
  const { data: healthProSpace } = useGetSpaceQuery();

  const { data: sharedProgrammes } = useGetSharedProgrammesQuery(
    healthProSpace?.id,
    {
      skip: !healthProSpace,
    },
  );

  return (
    <Select
      variant="standard"
      style={{ margin: 'auto 0', maxWidth: '270px' }}
      value={objectID || ''}
      displayEmpty
      onChange={(ev) => {
        const newValue = ev.target.value;
        onChangeObjectID(newValue);
      }}>
      <MenuItem value="">
        <em>Programs screen</em>
      </MenuItem>
      {(sharedProgrammes || []).map((sharedProgramme) => (
        <MenuItem key={sharedProgramme.id} value={sharedProgramme.id}>
          {sharedProgramme.title}
        </MenuItem>
      ))}
    </Select>
  );
};

AppLinkObjectIDPickerSharedProgrammes.propTypes = {
  objectID: PropTypes.string,
  onChangeObjectID: PropTypes.func.isRequired,
};

AppLinkObjectIDPickerSharedProgrammes.defaultProps = {
  objectID: '',
};

export default AppLinkObjectIDPickerSharedProgrammes;
